import { Component, model } from '@angular/core';

import { SellingCompanyReport } from '../../../models';

@Component({
  selector: 'app-report-footer',
  templateUrl: './report-footer.component.html',
  styleUrl: './report-footer.component.scss',
})
export class ReportFooterComponent {
  public readonly model = model<SellingCompanyReport>();
}
